import React from "react";
import * as styles from "./ellipsis.module.scss";

export const BottomEllipsis = React.memo(() => (
  <div className={styles.bottomEllipsis} />
));
